var cartTotal = 0,
    gwpQualificationProduct = false,
    gwpQualificationProductQuantity = 0,
    giftProductQuantity = 0,
    gwpPresent = false,
    gwpQualified = false;

const defaultCurrency = 'CAD',
    selectedCurrency = $('.currency-picker__label:first').text(),
    gwpContainer = '.gwp-container';

var gwpThreshold = 150;

function openGwp() {
    if (gwpQualified == true && !gwpPresent) {
        //$(gwpContainer).fadeIn('fast');
        //$('body').addClass('modal-open');

data = [];

   // Add to cart method for mobile

var bundle = $(this).data("block");
	

	bundleName = "Gift with Purchase";
  var feed = {'id':gwpId,'quantity':1,       "properties": {
        "Promo": bundleName
      }  };
    data.push(feed);
	//console.log(feed);
	//console.log(data);
   



window.themeCore.CartApi.makeRequest(themeCore.CartApi.actions.ADD_TO_CART_MANY, data
                                    ).then(res => {

        //$('.add-to-cart').text('Add to Cart');
    window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.UPDATE_CART);
    //window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);	
})       
    }
}

function getCart() {    
    setTimeout(function () {
        jQuery.ajax({
            type    : 'GET',
            url     : '/cart.js',
            dataType: 'json',
            success : function (cart) {
                cartTotal = 0;
                $.each(cart.items, function (i, f) {
                    var handle = f.handle;

                  /*
                    if (f.properties) {
                        if (f.properties.Promo == giftPropertyValue) {
                            gwpPresent = true;
                            giftId     = f.key;
                        } else {
                            if (handle.indexOf("gift-card") == -1) {
                                cartTotal += f.line_price;  
                            }                           
                        }
                    }
                  */

                  console.log(f);


$.each(f.properties, function (i, property) {
var str = property.toLowerCase();
                        if (i.indexOf("Promo") > -1) {
  
                                gwpPresent = true;
                                giftId     = f.key; 
                                //cartTotal = cartTotal - f.final_price   
                        }
});

      
                
                  
         
                        if (handle.indexOf("gift-card") == -1) {
                            cartTotal += f.line_price;  
                        }                     

                    if (f.handle == giftProduct && gwpQualificationType == 'collection') {
                        gwpPresent = true;
                    }

                    if (gwpQualificationType == 'collection' && f.handle == giftProduct) {
                        giftProductQuantity += f.quantity;
                    }

                    if ($.inArray(handle, qualificationProducts) !== -1 && gwpQualificationType == 'collection') {
                        gwpQualificationProduct = true;
                        gwpQualificationProductQuantity += f.quantity;
                    }
                });

              cartTotal = cartTotal / 100;
                if (gwpQualificationType == 'collection') {
                    if (cartTotal !== 0 && !gwpPresent) {
                        $('.gwp-reminder').fadeIn();
                    }
                  $('.gwp-qualified').hide();
                  $('.gwp-unqualified').hide();
                  $('.gwp-missing-item').hide();
                    switch (true) {
                        default:
                            $('.gwp-reminder').fadeIn();
                            break;
                        case (gwpQualificationProductQuantity > 0 && cartTotal > gwpThreshold):
                            $('.gwp-qualified').show();
                            gwpQualified = true;
                            break;
                        case (cartTotal < gwpThreshold):
                            $('.gwp-unqualified').show();
                            gwpQualified = false;
                            break;
                        case (gwpQualificationProductQuantity <= 0 && cartTotal > gwpThreshold):
                            $('.gwp-missing-item').show();
                            gwpQualified = false;
                            break;
                        case (giftProductQuantity > 0):
                            $('.gwp-reminder').fadeOut();
                            break;
                    }                  
                } else {                
                if (cartTotal !== 0 && !gwpPresent) {
                    $('.gwp-remainder').text(currencySymbol + (Math.round(gwpThreshold - cartTotal)));
                    if (cartTotal < gwpThreshold) {
                        $('.gwp-reminder').fadeIn();
                    }
                    

                    if (cartTotal < gwpThreshold || gwpQualificationType == 'product') {
                        $('.gwp-qualified').hide();
                        $('.gwp-unqualified').show();
                        $('.gwp-missing-item').hide(); 
                        gwpQualified = false;
                    } else {
                        $('.gwp-reminder').fadeOut();
                        $('.gwp-qualified').show();
                        $('.gwp-unqualified').hide();
                        $('.gwp-missing-item').hide();
                        gwpQualified = true;                      
                    }
                } else {
                    $('.gwp-reminder').fadeOut();
                    if (cartTotal == 0) {
                        gwpQualified = false;
                    }               
                }                  
                }

                openGwp(cartTotal);

                if ((gwpPresent && cartTotal < gwpThreshold) && gwpQualificationType == 'cart_total') {
                    jQuery.ajax({
                        type    : 'POST',
                        url     : '/cart/change.js',
                        data    : 'quantity=0&id=' + giftId,
                        dataType: 'json',
                        success : function (cart) {
                            //document.cookie = 'gwp=;expires=Thu, 01 Jan 1970 00:00:01 GMT;path=/;';
                            //location.reload();
                            window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.UPDATE_CART);
                            window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
                            gwpPresent = false;
                            getCart();
                        },
                        error   : function (XMLHttpRequest, textStatus) {
                            Shopify.onError(XMLHttpRequest, textStatus);
                        }
                    });
                }
                $('.gwp-progress').width(((cartTotal/gwpThreshold) * 100).toFixed(2) + '%');
                $('.gwp-remaining').text(currencySymbol + (gwpThreshold - cartTotal));
                $('.gwp-qualification').text(currencySymbol + gwpThreshold);              
            }.bind(this),
            error   : function (XMLHttpRequest, textStatus) {
                Shopify.onError(XMLHttpRequest, textStatus);
            }
        });
    }, 3000);
}

$(window).on('load', function () {
    discountedPrice = currencySymbol + giftPrice1 * 100 / 100;
    $('.discounted-price-1').html(discountedPrice);

    discountedPrice = currencySymbol + giftPrice2 * 100 / 100;
    $('.discounted-price-2').html(discountedPrice);
    getCart();
});

$(document).on('mouseup', '.add-to-cart', function () {
    getCart();
});

$(document).on('click', gwpContainer + ' .modal__close, .gwp-background', function () {
    var today  = new Date();
    var expire = new Date();
    expire.setTime(today.getTime() + 3600000 * 24 * 14); // 14 days
    document.cookie = "gwp-h-b-tote-bag=1; path=/; expires=" + expire.toGMTString();
    $(gwpContainer).fadeOut('fast');
    $('body').removeClass('modal-open');
});

  $(document).on('click', '.gwp-add', function (e) {
window.themeCore.CartApi.makeRequest(themeCore.CartApi.actions.ADD_TO_CART, {
   'id': $(this).siblings('.gift_id').val(),
	 'quantity': 1,
      "properties": {
        "Promo": giftPropertyValue
      }  
}).then(res => {
    $(gwpContainer).fadeOut('fast');
    $('body').removeClass('modal-open');
  setTimeout(function () {
    window.loyaltylion && window.loyaltylion.ui.refresh();
    }, 1000);
})
.catch(e => {
	// Errors handling
  console.log(JSON.stringify(e));
  console.log($(this).siblings('.gift_id').val());
});  
    e.preventDefault();
});


$(document).on('click', '.js-cart-item-remove, .header__icon--cart, .quantity', function () {
    gwpPresent = false;
    gwpQualificationProductQuantity = 0;
    getCart();
});

// GWP modal variant selection
$(document).on('click', gwpContainer + ' .variant-input', function () {
    $(this).parents('.gift-product').find('.gift-image').attr('src', $(this).find('input').data('image'));
    $(this).parents('.gift-product').find('.gift_id').val($(this).find('input').val());

    $(gwpContainer).find(gwpContainer + ' .variant-input input').attr('checked', false);
    $(this).find('input').attr('checked', true);

    if (gwpDiscountType == 'percent') {
        variantPrice    = $(this).find('input').data('price');
        discountedPrice = Math.round(Currency.convert(variantPrice, defaultCurrency, selectedCurrency) * 100) / 100;
        discountedPrice = discountedPrice * gwpPercentPrice / 100;
        $('.product__price del').html(currencySymbol + variantPrice);
        $('.discounted-price').html(currencySymbol + discountedPrice);
    }
});





















$(document).on('click', '.js-toggle-attribute', function() {
    event.preventDefault();

    var loadingMessage = "Adding gift packaging..."
    var giftDefaultLabel = $(this).parents('.cart-item__gift-wrap').find('.gift-wrap-label').text();
    

    var lineKey = $(this).data('line-key');
    var quantity = $(this).parents('.cart-item__col').find('.quantity__input').val();

    var propertyValue = "";  
    if ($(this).is(':checked')) {
        var propertyValue = "Yes";
    } else {
        var propertyValue = "";
        var loadingMessage = "Removing gift packaging..."
    }
    
    $(this).parents('.cart-item__gift-wrap').find('.gift-wrap-label').text(loadingMessage);
    $(this).parents('.cart-item__gift-wrap').find('.loading').show();
    $(this).parents('.cart-item__gift-wrap').find('.js-toggle-attribute').hide();
    $(this).prop("disabled", true);

    var requestBody = {
        id: lineKey, 
        quantity: quantity,
        properties: {
            "Gift Wrap Added": propertyValue
        }
    };

    //alert(JSON.stringify(propertyValue));

    jQuery.ajax({
        type    : 'POST',
        url     : '/cart/change.js',
        //data: '{"id":"41298232868975:14eda5f9beec181ef28e67cfdc25497b", "properties":{ "Gift Wrap Added": "Yes" } }', 
        contentType: "application/json",
        dataType: 'json',                 
        data: JSON.stringify(requestBody),  

        success : function (cart) {
            window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.UPDATE_CART);
            window.themeCore.CartApi.makeRequest(window.themeCore.CartApi.actions.GET_CART);
    $(this).parents('.cart-item__gift-wrap').text(giftDefaultLabel);
    $$(this).parents('.cart-item__gift-wrap').find('.loading').hide();
    $(this).parents('.cart-item__gift-wrap').find('.js-toggle-attribute').show();
    $(this).prop("disabled", false);         
        },
        error   : function (XMLHttpRequest, textStatus) {
            //Shopify.onError(XMLHttpRequest, textStatus);
            //alert(JSON.stringify(XMLHttpRequest));
    $(this).parents('.cart-item__gift-wrap').text(giftDefaultLabel);
    $(this).parents('.cart-item__gift-wrap').find('.loading').hide();
    $(this).parents('.cart-item__gift-wrap').find('.js-toggle-attribute').show();
    $(this).prop("disabled", false);        
        }
    }); 
});
